// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../Aphrodite.Admin.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cixM79PrbdHrlgFmMLej{transition:stroke-dasharray 300ms linear}`, "",{"version":3,"sources":["webpack://./node_modules/aphrodite.react/Components/Doughnut/Doughnut.module.scss"],"names":[],"mappings":"AAAA,sBACI,wCAAA","sourcesContent":[".dashTransition{transition:stroke-dasharray 300ms linear}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashTransition": `cixM79PrbdHrlgFmMLej`
};
export default ___CSS_LOADER_EXPORT___;
